import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

const VARIANTS = {
  primary:   'bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-800 border border-brand-600 shadow-soft',
  secondary: 'bg-white text-slate-700 hover:bg-slate-50 active:bg-slate-100 border border-slate-200 shadow-soft',
  ghost:     'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 border border-transparent',
  outline:   'bg-white text-brand-700 hover:bg-brand-50 border border-brand-200',
  danger:    'bg-rose-600 text-white hover:bg-rose-700 active:bg-rose-800 border border-rose-600 shadow-soft',
  success:   'bg-emerald-600 text-white hover:bg-emerald-700 active:bg-emerald-800 border border-emerald-600 shadow-soft',
  subtle:    'bg-slate-100 text-slate-700 hover:bg-slate-200 border border-transparent'
};

const SIZES = {
  xs:     'h-7 px-2.5 text-xs gap-1',
  sm:     'h-8 px-3 text-[13px] gap-1.5',
  md:     'h-9 px-4 text-sm gap-2',
  lg:     'h-11 px-5 text-sm gap-2',
  icon:   'h-9 w-9 p-0',
  iconSm: 'h-7 w-7 p-0'
};

const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    loading = false,
    disabled = false,
    className,
    children,
    type = 'button',
    ...rest
  },
  ref
) {
  const isDisabled = disabled || loading;
  return (
    <button
      ref={ref}
      type={type}
      disabled={isDisabled}
      className={cn(
        'inline-flex items-center justify-center font-medium rounded-md transition-all duration-150 ease-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...rest}
    >
      {loading ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : LeftIcon ? (
        <LeftIcon className="h-3.5 w-3.5 shrink-0" />
      ) : null}
      {children}
      {!loading && RightIcon ? <RightIcon className="h-3.5 w-3.5 shrink-0" /> : null}
    </button>
  );
});

export default Button;
